<template>
    <div>
        <div class="position-relative">
            <span class="notifications-icon d-block position-relative" @click="getNotifications()">
                <span v-if="unread"
                      class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger notification-number">
                    {{ unread }}
                </span>
            </span>

            <div class="notifications-list hide">
                <div class="fw-bold px-2 py-1 list-header">Notifications</div>

                <ul v-if="notifications.length" class="list-unstyled p-3 list-body mb-0">
                    <li class="p-3 mb-3 bg-main d-flex" v-for="notification in notifications"
                        :class="!notification.isRead ? 'bg-is-not-read ' : ''">
                        <div v-if="notification.giverUserId && !notification.receiverUserId">
                            <span v-html="notification.sentence.split('{giver_user.name}')[0]"></span>

                            <UserPopin :user-id="notification.giverUserId" :unique-id="notification.giverUniqueId"
                                       class="link-like text-decoration-none d-inline">
                                <span>{{ notification.giverUserPseudo }}</span>
                            </UserPopin>

                            <span v-html="notification.sentence.split('{giver_user.name}')[1]"></span>
                        </div>

                        <div v-else-if="notification.giverUserId === null && notification.receiverUserId">
                            <span v-html="notification.sentence.split('{receiver_user.name}')[0]"></span>

                            <UserPopin :user-id="notification.giverUserId" :unique-id="notification.giverUniqueId"
                                       class="link-like text-decoration-none d-inline">
                                <span>{{ notification.receiverUserPseudo }}</span>
                            </UserPopin>

                            <span v-html="notification.sentence.split('{receiver_user.name}')[1]"></span>
                        </div>

                        <div v-else-if="notification.giverUserId === null && notification.receiverUserId">
                            <span v-html="notification.sentence.split('{giver_user.name}')[0]"></span>

                            <UserPopin :unique-id="notification.giverUniqueId" :user-id="notification.giverUserId"
                                       class="link-like me-2 text-decoration-none">
                                <span class="text-black"> {{ notification.giverUserPseudo }}</span>
                            </UserPopin>

                            <span
                                v-html="notification.sentence.split('{giver_user.name}')[1].split('{receiver_user.name}')[0]"></span>

                            <UserPopin :unique-id="notification.receiverUniqueId" :user-id="notification.receiverUserId"
                                       class="link-like me-2 d-flex text-decoration-none">
                                <span class="text-black"> {{ notification.receiverUserPseudo }}</span>
                            </UserPopin>

                            <span
                                v-html="notification.sentence.split('{giver_user.name}')[1].split('{receiver_user.name}')[1]"></span>
                        </div>

                        <span v-else>
                            <RenderString :string="notification.sentence"/>
                        </span>
                    </li>
                </ul>

                <div v-else-if="zero">
                    <p class="text-center pt-2">Aucune notification</p>
                </div>

                <div v-else class="spinner-border d-flex mx-auto text-danger text-center my-4" role="status">
                    <span class="visually-hidden">Chargement des notifications...</span>
                </div>

                <span v-else v-html="notification.sentence"></span>

                <div class="fw-bold px-2 py-1 list-footer text-center">
                    <a :href="route('users.notifications')" title="Voir toutes les notifications">Voir toutes les
                        notifications</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import RenderString from "../../RenderString.js"
import UserPopinComponent from "../UserPopinComponent";


export default {
    name: 'notification-component',
    components: {'UserPopin': UserPopinComponent},
    props: {
        counter: Number
    },
    data() {
        return {
            notifications: [],
            unread: this.counter,
            zero: false
        }
    },

    methods: {
        getNotifications() {
            const notificationMenu = document.querySelector('.notifications-list');
            notificationMenu.classList.toggle('hide');
            this.notifications = [];

            axios.get('/api/v1/users/notifications')
                .then((response) => {
                    if (response.data) {
                        this.unread = 0;
                        if (response.data.length) {
                            response.data.forEach(notification => {
                                this.notifications.push(notification);

                                if (!notification.isRead) {
                                    this.unread++;
                                }

                                this.zero = false;
                            });
                        } else {
                            this.zero = true;
                        }
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    }
}
</script>
